import { ReviewPageConfig, ReviewPageConfigSettings } from "@/services/bedrock";

const TEXT_MAX_LENGTH = 255;

type LiquidField = "headline" | "subtitle";
type LiquidFieldErrors = Partial<Record<LiquidField, string>>;

const getReviewPageSettings = (config: ReviewPageConfig): ReviewPageConfigSettings => ({
  formId: config.formId ?? null,
  contentPageThemeId: config.contentPageThemeId ?? null,
  headline: config.headline ?? null,
  subtitle: config.subtitle ?? null,
  showStarSummary: config.showStarSummary,
  showSentimentSummary: config.showSentimentSummary,
  showNpsSummary: config.showNpsSummary,
  useCondensedQuotes: config.useCondensedQuotes,
  approvedForSocialOnly: config.approvedForSocialOnly,
  reviewSortType: config.reviewSortType,
  showReviewReplies: config.showReviewReplies,
  showSourceFilter: config.showSourceFilter,
  showOfficeDetails: config.showOfficeDetails,
  showContactButton: config.showContactButton,
  showSocialLinks: config.showSocialLinks,
});

const reviewPagePreviewParams = (settings: Partial<ReviewPageConfigSettings>): URLSearchParams =>
  new URLSearchParams(
    Object.entries(settings).map(([key, value]) => [key, value === null || value === undefined ? "" : String(value)])
  );

const LIQUID_FIELD_LABELS: Record<string, LiquidField> = { Headline: "headline", Subtitle: "subtitle" };

const liquidFieldErrors = (message: unknown): LiquidFieldErrors => {
  if (typeof message !== "string") return {};
  const errors: LiquidFieldErrors = {};
  const pattern = /(Headline|Subtitle) (.+?)(?=, (?:Headline|Subtitle) |$)/g;
  for (const [, label, error] of message.replace(/^Validation failed: /, "").matchAll(pattern)) {
    errors[LIQUID_FIELD_LABELS[label]] = `${label} ${error}.`;
  }
  return errors;
};

export { TEXT_MAX_LENGTH, getReviewPageSettings, reviewPagePreviewParams, liquidFieldErrors };
export type { LiquidField, LiquidFieldErrors };
